export default "__VITE_ASSET__8974091d__"